import React, { Component } from "react";
import { Helmet } from "react-helmet";
import "../../common/index.scss";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  setSearchedProductsArray,
  getAllBookingsOfSingleUserRedux,
  getAllShipForMeOfSingleUserRedux,
  getAllOrdersApiRedux,
  getAllBannersRedux,
  getAllCampaignsRedux,
  getAllHomeCategoryRedux,
  uploadAliProducts,
  setIntroModal,
} from "../../../actions";
import { fetchOnce } from "./mainCache";
import CollectionTwo from "./collection2";
import CollectionThree from "./collection3";
import {
  getAllFirestoreAliProductsList,
  uploadImageRechargeRequest,
  getSelectedIntroModal,
} from "../../../firebase/firebase.utils";
import "./main.css";
import Shop from "./shop";
import BuyAndShipForMe from "./buyAndShipForMe.png";
import ShipForMe from "./shipForMe.png";
import IntroModal from "./IntroModal";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import Axios from "axios";
import { ClipLoader } from "react-spinners";

const categories = [
  { name: "Bags", img: "/images/categories/bags.png" },
  { name: "Shoes", img: "/images/categories/shoes.png" },
  { name: "Jewelry", img: "/images/categories/jewelry.png" },
  { name: "Beauty Products", img: "/images/categories/beauty.png" },
  { name: "Mens Clothing", img: "/images/categories/mens.png" },
  { name: "Womens Clothing", img: "/images/categories/womens.png" },
  { name: "Baby Items", img: "/images/categories/baby.png" },
  { name: "Sunglass", img: "/images/categories/sunglass.png" },
  { name: "Phone Accessories", img: "/images/categories/phone.png" },
  { name: "Fitness", img: "/images/categories/fitness.png" },
  { name: "Watches", img: "/images/categories/watch.png" },
  { name: "Food Items", img: "/images/categories/grocery.png" },
  { name: "Traveling", img: "/images/categories/travel.png" },
  { name: "Gadgets", img: "/images/categories/gadgets.png" },
];

class Pets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBarValue: "",
      shippingValue: "Ship for me",
      image: BuyAndShipForMe,
      campaigns: [],
      visibleCategories: [],
      imgLoading: false,
    };
    this.scrollRef = React.createRef();
  }
  scroll = (dir) => {
    if (this.scrollRef.current) {
      this.scrollRef.current.scrollBy({
        left: dir === "left" ? -200 : 200,
        behavior: "smooth",
      });
    }
  };
componentDidMount = () => {
  // 👉 1️⃣ Render categories IMMEDIATELY (fast, lightweight)
  this.updateCategories();

  

  // 👉 2️⃣ Defer heavy logic so browser can paint quickly
  setTimeout(async () => {
       // Cache Banners (10 minutes)
    fetchOnce("banners", 10 * 60 * 1000, async () => {
      await this.props.getAllBannersRedux();
      return this.props.banners;
    });
    // Intro modal
    const introModal = await getSelectedIntroModal();
    this.props.setIntroModal(introModal);
    if (introModal) document.getElementById("intro-modal").click();

    // Cache Home Categories (10 minutes)
    fetchOnce("home-categories", 10 * 60 * 1000, async () => {
      await this.props.getAllHomeCategoryRedux();
      return this.props.homeCategories;
    });
    // Cache Campaigns (10 minutes)
    fetchOnce("campaigns", 10 * 60 * 1000, async () => {
      await this.props.getAllCampaignsRedux();
      return this.props.campaigns;
    });

    // Cache User Data (if logged in)
    if (this.props.currentUser.id) {
      const uid = this.props.currentUser.id;

      fetchOnce(`bookings-${uid}`, 10 * 60 * 1000, async () => {
        await this.props.getAllBookingsOfSingleUserRedux(uid);
        return this.props.bookingsArray;
      });

      fetchOnce(`shipforme-${uid}`, 10 * 60 * 1000, async () => {
        await this.props.getAllShipForMeOfSingleUserRedux(uid);
        return this.props.shipForMesArray;
      });

      fetchOnce(`orders-${uid}`, 10 * 60 * 1000, async () => {
        await this.props.getAllOrdersApiRedux(uid);
        return this.props.orders;
      });
    }

    // Tick timer logic
    if (this.props.campaigns.length > 0) {
      this.timerID = setInterval(() => this.tick(), 1000);
    }

  }, 0); // End of setTimeout

  // 👉 3️⃣ Resize listener (NOT deferred)
  window.addEventListener("resize", this.updateCategories);
};


  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.currentUser.id &&
      nextProps.currentUser.id !== this.props.currentUser.id
    ) {
      this.props.getAllBookingsOfSingleUserRedux(nextProps.currentUser.id);
      this.props.getAllShipForMeOfSingleUserRedux(nextProps.currentUser.id);
      this.props.getAllOrdersApiRedux(nextProps.currentUser.id);
    }
    if (nextProps.campaigns.length > 0) {
      this.timerID = setInterval(() => this.tick(), 1000);
    }
  };
  componentWillUnmount = () => {
    clearInterval(this.timerID);
    window.removeEventListener("resize", this.updateCategories);
    this.setState({ searchBarValue: "" });
  };

  updateCategories = () => {
    const isMobile = window.innerWidth <= 768;
    const visibleCategories = isMobile ? categories.slice(0, 9) : categories;
    this.setState({ visibleCategories });
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };
  handleSearchBarSubmit = (event) => {
    event.preventDefault();
    if (this.state.searchBarValue.length < 35) {
      var win = window.open(
        `${process.env.PUBLIC_URL}/collection/${this.state.searchBarValue}`,
        "_blank"
      );
      win.focus();
    } else {
      this.props.setSearchedProductsArray(0, []);
      if (this.state.searchBarValue.includes("1688")) {
        let productId = this.state.searchBarValue.split("/")[4].split(".")[0];
        console.log(productId);

        var win = window.open(
          `${process.env.PUBLIC_URL}/product/${productId}`,
          "_blank"
        );
        win.focus();
      } else {
        let taobaoUrl = new URL(this.state.searchBarValue);
        let params = taobaoUrl.search;
        const urlParams = new URLSearchParams(params);
        const id = urlParams.get("id");
        var win = window.open(
          `${process.env.PUBLIC_URL}/product/${id}`,
          "_blank"
        );
        win.focus();
      }
    }
    this.setState({ searchBarValue: "" });
  };

  handleNextClick = () => {
    if (this.state.shippingValue == "Ship for me") {
      this.props.history.push(`${process.env.PUBLIC_URL}/pages/ship-for-me`);
    } else if (this.state.shippingValue === "Buy and ship for me") {
      this.props.history.push(`${process.env.PUBLIC_URL}/pages/buy-for-me`);
    } else {
      this.props.history.push(
        `${process.env.PUBLIC_URL}/pages/request-for-product`
      );
    }
  };

  handleImgChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    this.setState({
      imgLoading: true,
    });

    // 👇 Get Data URL for preview (not the same as pure base64 for upload)
    const reader = new FileReader();
    reader.onload = () => {
      const imageDataUrl = reader.result; // includes "data:image/jpeg;base64,..."
      localStorage.setItem("uploadedImagePreview", imageDataUrl); // 🧠 Persist it
      this.setState({ imageUrl: imageDataUrl }); // Show it
    };
    reader.readAsDataURL(file);

    const base64 = await this.resizeAndCompressImage(file);

    console.log(base64);
    if (base64 === this.state.lastImageBase64) {
      console.log("Image is the same, skipping upload.");
      return;
    }

    this.setState({ lastImageBase64: base64 });
    const resultObj = await Axios.post("/api/products/upload-image", {
      imageBase64: base64,
    });

    console.log(resultObj);
    if (
      resultObj.data &&
      resultObj.data.result &&
      resultObj.data.result.result
    ) {
      this.setState({ imgLoading: false });
      this.openPage(resultObj.data.result.result);
    } else {
      this.setState({ imgLoading: false });
      alert("There was an error uploading your image.");
    }
  };
  resizeAndCompressImage = (
    file,
    maxWidth = 500,
    maxHeight = 500,
    quality = 0.7
  ) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = (e) => {
        img.src = e.target.result;
      };

      img.onload = () => {
        const canvas = document.createElement("canvas");
        let { width, height } = img;

        // Maintain aspect ratio
        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        // Compress image to JPEG format
        const compressedBase64 = canvas.toDataURL("image/jpeg", quality); // quality from 0 to 1
        resolve(compressedBase64.split(",")[1]); // remove 'data:image/jpeg;base64,'
      };

      img.onerror = (err) => {
        reject(err);
      };
    });
  };
  openPage = (imgUrl) => {
    this.props.history.push(
      `${process.env.PUBLIC_URL}/collection/img_uploads?imageUrl=${imgUrl}`
    );
  };

  tick = () => {
    let campaigns = this.props.campaigns.map((campaign) => {
      if (campaign && campaign.expiryDate) {
        const [year, month, day] = campaign.expiryDate.split("-");
        let dateFuture = new Date(
          parseInt(year),
          parseInt(month - 1),
          parseInt(day)
        );
        let dateNow = new Date();
        var seconds = Math.floor((dateFuture - dateNow) / 1000);
        var minutes = Math.floor(seconds / 60);
        var hours = Math.floor(minutes / 60);
        var days = Math.floor(hours / 24);

        hours = hours - days * 24;
        minutes = minutes - days * 24 * 60 - hours * 60;
        seconds =
          seconds - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60;

        return { ...campaign, days: days + 1, hours, minutes, seconds };
      }
    });
    this.setState({ campaigns });
  };

  render() {
    const {
      bookingsArray,
      shipForMesArray,
      orders,
      banners,

      homeCategories,
      items,
    } = this.props;
    const { campaigns } = this.state;
    console.log(homeCategories);
    let totalItems = 0;
    this.props.cart.map((shop) => {
      return (totalItems += shop.items.length);
    });

 
    // let shippingBanner = "";
    // if (banners.find((banner) => banner.secondBanner)) {
    //   shippingBanner = banners.find((banner) => banner.secondBanner).banner;
    // } else {
    //   setTimeout(() => {
    //     shippingBanner = "/assets/images/home-banner/ship_for_me.jpg";
    //   }, 300);
    // }
     
    console.log(banners);
    return (
      <div style={{ position: "relative" }}>
        <Helmet>
          <title>
            Alg | A cross border shopping platform for Bangladeshi Smart
            Shoppers
          </title>
        </Helmet>

        <div className="top-searchbar-parent hide-searchbar-for-pc">
          <div className="top-searchbar-container-2">
            <form
              className="form_search top-form form-search2"
              role="form"
              onSubmit={this.handleSearchBarSubmit}
              style={{
                borderRadius: "0px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <input
                id="query search-autocomplete"
                type="search"
                placeholder="Search 100+ millions of products"
                value={this.state.searchBarValue}
                onChange={this.handleChange}
                name="searchBarValue"
                className="nav-search nav-search-field"
                aria-expanded="true"
                style={{ color: "black" }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                }}
              >
                <div
                  className="btn-search"
                  style={{
                    width: "40px",
                    position: "relative",
                  }}
                >
                  <i
                    className="fa fa-camera"
                    style={{
                      color: "#ff4c3b",
                      marginTop: 12,
                      fontSize: "150%",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      window.document
                        .getElementById("upload-image-input12")
                        .click();
                    }}
                  />
                </div>
                <button
                  type="submit"
                  style={{
                    position: "relative",
                    backgroundColor: "#ff4c3b",
                    minHeight: "100%",
                    marginTop: -5,
                    marginRight: -5,
                    borderRadius: 0,
                  }}
                  onClick={this.handleSearchBarSubmit}
                >
                  {this.state.imgLoading ? (
                    <ClipLoader
                      loading={this.state.imgLoading}
                      color="white"
                      size={20}
                    />
                  ) : (
                    <i
                      className="fa fa-search"
                      style={{
                        color: "white",
                        margin: "auto",
                        padding: "5px 13px",
                        fontSize: "120%",
                      }}
                    />
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div>
          <div
            style={{
              background: "whitesmoke",
              minWidth: "100%",
              maxWidth: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div className="slider-container-homepage">
              {banners.length > 0 ? (
                <Slider
                  autoplay={true}
                  autoplaySpeed={5000}
                  dots={true}
                  // infinite={true}
                  speed={2000}
                  slidesToScroll={1}
                  slidesToShow={1}
                  lazyLoad={false}
                  arrows={false}
                  className="slider-image-container-div"
                >
                  {banners
                    .filter((banner) => !banner.secondBanner)
                    .map((banner) => (
                      <img
                        src={banner.banner ? banner.banner : ""}
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                        }}
                      />
                    ))}{" "}
                </Slider>
              ) : (
                <Skeleton className="slider-skeleton" />
              )}
            </div>
            <div
              style={{
                padding: 20,
                paddingLeft: 0,
                width: "100%",
              }}
              className="second-banner-hide-for-mobile"
            >
              <div>
                {banners.length > 0 ? (
                  banners
                    .filter((banner) => banner.secondBanner)
                    .map((banner) => (
                      <img
                        src={banner.banner ? banner.banner : "./45.jpg"}
                        style={{
                          width: "100%",
                          borderRadius: 10,
                        }}
                      />
                    ))
                ) : (
                  <Skeleton style={{ height: 400 }} />
                )}{" "}
              </div>
            </div>
          </div>
        </div>

        <div className="category-slider-wrapper">
          <button
            className="scroll-btn left"
            onClick={() => this.scroll("left")}
          >
            ◀
          </button>

          <div className="category-slider" ref={this.scrollRef}>
            {this.state.visibleCategories.map((cat, index) => (
              <div
                key={index}
                className="category-card"
                onClick={() => {
                  this.props.history.push(`${process.env.PUBLIC_URL}/collection/${cat.name}`)
                }}
              >
                <img src={cat.img} alt={cat.name} className="category-image" />
                <p className="category-name">{cat.name}</p>
              </div>
            ))}
          </div>

          <button
            className="scroll-btn right"
            onClick={() => this.scroll("right")}
          >
            ▶
          </button>
        </div>

        {campaigns.length > 0 && (
          <div
            style={{ margin: "0px auto", marginTop: 40 }}
            className="campaign-container"
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  color: "#ff4a4e",
                  fontSize: 28,
                  marginTop: -20,
                }}
              >
                Campaigns
              </span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  color: "#f48110",
                  marginRight: 12,
                  cursor: "pointer",
                }}
                onClick={() => {
                  this.props.history.push("/campaigns/all-campaigns");
                }}
              >
                View all ►►
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                flexWrap: "wrap",
                marginTop: "20px",
              }}
              className="each-campaign-container"
            >
              {campaigns.map((campaign) => (
                <a
                  target="_blank"
                  href={`/collection/${campaign.categoryId}?category_id=${campaign.categoryId}`}
                  className="each-campaign"
                  style={{
                    position: "relative",
                    backgroundImage: `url(${campaign.banner})`,
                    backgroundSize: "cover",
                    borderRadius: 10,
                    cursor: "pointer",
                    display: "block",
                  }}
                >
                  <div
                    style={{
                      color: "white",
                      position: "absolute",
                      top: "-3px",
                      right: 0,
                    }}
                  >
                    <span
                      style={{
                        background: "white",
                        padding: 5,
                        borderRadius: 10,
                        color: "black",
                        border: "2px solid #ec345b",
                      }}
                    >
                      {campaign.days}days
                    </span>{" "}
                    :{" "}
                    <span
                      style={{
                        background: "white",
                        padding: 5,
                        borderRadius: 10,
                        color: "black",
                        border: "2px solid #ec345b",
                      }}
                    >
                      {campaign.hours}hrs
                    </span>{" "}
                    :{" "}
                    <span
                      style={{
                        background: "white",
                        padding: 5,
                        borderRadius: 10,
                        color: "black",
                        border: "2px solid #ec345b",
                      }}
                    >
                      {campaign.minutes}mins
                    </span>{" "}
                    :{" "}
                    <span
                      style={{
                        background: "white",
                        padding: 5,
                        borderRadius: 10,
                        color: "black",
                        border: "2px solid #ec345b",
                      }}
                    >
                      {campaign.seconds}secs
                    </span>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      background: "#ff4a4e",
                      minWidth: "100%",
                      padding: "15px",
                      fontWeight: "bold",
                      color: "white",
                      borderBottomRightRadius: "5px",
                      borderBottomLeftRadius: "5px",
                    }}
                    className="campaign-name"
                  >
                    {campaign.name}
                  </div>
                </a>
              ))}{" "}
            </div>
          </div>
        )}
        {/*Product Section*/}

        <CollectionThree
          type={"others"}
          status={"in-stock"}
          title={"Winter Collection"}
          subtitle=""
          categoryId={"Winter Collection"}
        />
        <CollectionThree
          type={"others"}
          status={"in-stock"}
          title={"Men's Jacket"}
          subtitle=""
          categoryId={"Men's Jacket"}
        />
        <CollectionThree
          type={"others"}
          status={"in-stock"}
          title={"Ladies Bags"}
          subtitle=""
          categoryId={"Ladies Bags"}
        />
        <CollectionThree
          type={"others"}
          status={"in-stock"}
          title={"Men's Shoes"}
          subtitle=""
          categoryId={"Men's Shoes"}
        />
        <CollectionThree
          type={"others"}
          status={"in-stock"}
          title={"Appliances"}
          subtitle=""
          categoryId={"Appliances"}
        />
        <CollectionThree
          type={"others"}
          status={"in-stock"}
          title={"Fashion"}
          subtitle=""
          categoryId={"Fashion"}
        />

        {homeCategories.length > 0 &&
          homeCategories.map((cat) => (
            <CollectionTwo
              type={"others"}
              status={"in-stock"}
              title={cat.name}
              subtitle=""
              categoryId={cat.categoryId}
            />
          ))}
        {/* <div
          style={{
            marginTop: 15,
            background: "white",
            padding: "20px 0px",
            borderRadius: 5,
            margin: "auto",
          }}
          className="how-alg-works"
        >
          <div className="how-globalbuybd-parent">
            <div className="how-globalbuybd"> HOW ALG WORKS</div>
            <div style={{ marginTop: 10 }}>
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  style={{
                    textAlign: "center",
                    padding: 0,
                    paddingBottom: 10,
                    marginLeft: 20,
                    borderBottom:
                      this.state.image == BuyAndShipForMe
                        ? "2px solid #ff4a4e"
                        : "0px",
                    color:
                      this.state.image == BuyAndShipForMe ? "#ff4a4e" : "black",
                    fontWeight:
                      this.state.image == BuyAndShipForMe ? "bold" : "normal",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    this.setState({ image: BuyAndShipForMe });
                  }}
                >
                  Buy and Ship For me
                </div>
              </div>
            </div>
          </div>
          <div style={{ paddingLeft: 10, marginTop: 10, paddingRight: 10 }}>
            <img
              src={this.state.image}
              style={{
                width: "100%",
                borderRadius: 10,
              }}
            />
          </div>
        </div> */}

        <IntroModal />
        <input
          id="upload-image-input12"
          className="upload"
          type="file"
          accept="image/*"
          ref={this.fileInputRef}
          style={{
            position: "absolute",
            zIndex: 5,
            maxWidth: "50px",
            marginTop: "10px",
            display: "none",
          }}
          onChange={this.handleImgChange}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.user.currentUser,
    cart: state.cartList.cart,
    bookingsArray: state.bookingRequests.bookingsArrayOfSingleUser,
    shipForMesArray: state.bookingRequests.shipForMeOfSingleUser,
    orders: state.orders.ordersApi,
    banners: state.orders.banners,
    campaigns: state.orders.campaigns,
    homeCategories: state.user.homeCategories,
    items: state.data.products,
  };
};
export default connect(mapStateToProps, {
  setSearchedProductsArray,
  getAllBookingsOfSingleUserRedux,
  getAllShipForMeOfSingleUserRedux,
  getAllOrdersApiRedux,
  getAllBannersRedux,
  getAllCampaignsRedux,
  getAllHomeCategoryRedux,
  setIntroModal,
})(Pets);
